// @ts-check
import React, { Component } from "react"
import { createPortal } from "react-dom"
import { BlockContextConsumer } from "../ContextProviders"
import DisplayBroadcast from "../broadcast/DisplayBroadcast"

class BlockValidationsPortal extends Component {
    getList = context =>
        context.block.config.broadcast.filter(({ channel }) => channel === "validation")
    render() {
        const children = (
            <BlockContextConsumer>
                {context =>
                    context.block &&
                    ((!this.getList(context).length && <em>(none)</em>) || (
                        <div onClick={event => event.stopPropagation()}>
                            Emitted validation:
                            <br />
                            <ul>
                                {this.getList(context).map(broadcast => (
                                    <li>
                                        <DisplayBroadcast
                                            broadcast={broadcast}
                                            showDescription={true}
                                        />
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))
                }
            </BlockContextConsumer>
        )

        return createPortal(children, document.getElementById("validation"))
    }
}

BlockValidationsPortal.propTypes = {}

export default BlockValidationsPortal



// WEBPACK FOOTER //
// ./src/features/editor/validation/BlockValidationsPortal.js